import React, { useState, useEffect, useRef } from 'react';
import { FaChevronDown, FaRegUserCircle } from '../../Data/Icons';
import LOGO from '../../assets/logo2.png';
import { useDispatch } from '../../Data/Imports';
import { signOut } from '../../Redux/features/auth/authSlice';

const Navbar = () => {
	const [isProfileOpen, setIsProfileOpen] = useState(false);
	const dispatch = useDispatch();

	const profileRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (profileRef.current && !profileRef.current.contains(event.target)) {
				setIsProfileOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleLogout = () => {
		dispatch(signOut());
	};

	return (
		<nav className='relative z-10 shadow-lg h-20 bg-[#fff]'>
			<div className='flex items-center justify-between px-6 py-4'>
				{/* Left Section */}
				{/* <div className='flex flex-col'>
					<h1 className='text-2xl font-bold text-[#A9C46C]'>Welcome,</h1>
				</div> */}

				{/* Sidebar Header */}
				<div className='flex  md:ml-64 sm:m-auto'>
					<img src={LOGO} alt='Logo' className='w-52 md:w-52 sm:m-auto' />
				</div>

				{/* Right Section */}
				<div className='flex items-center space-x-6'>
					{/* Profile Dropdown */}
					<div className='relative' ref={profileRef}>
						<div
							className='flex items-center cursor-pointer'
							onClick={() => setIsProfileOpen(!isProfileOpen)}>
							<FaRegUserCircle className='text-2xl' />
							<FaChevronDown className='ml-2 text-gray-500' />
						</div>
						{isProfileOpen && (
							<div
								className='absolute right-0 mt-2 w-48 bg-white shadow-md rounded-md z-50'
								style={{ position: 'fixed', top: '4rem', right: '2rem' }}>
								<ul className='text-sm text-gray-700'>
									<li onClick={handleLogout} className='p-2 hover:bg-gray-100 cursor-pointer'>
										Logout
									</li>
								</ul>
							</div>
						)}
					</div>
				</div>
			</div>
			<hr />
		</nav>
	);
};

export default Navbar;
